import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
  ResolveStart,
  ResolveEnd
} from "@angular/router";
import { PageEvent } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { zip } from 'rxjs/observable/zip';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { interval } from "rxjs/observable/interval";
import { map, switchMap, publish, tap, take, filter, throttle } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';
import { Query } from '../products/query';
import { takeWhile } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfigurationService } from '../configuration.service';
import { Configuration } from '../configuration';
import { MatGridList, MatPaginator } from "@angular/material";
import { MediaChange, ObservableMedia } from '@angular/flex-layout';
import { ProductsService } from "../products/products.service";
import { Category, Product, CategoryResponse, CategoryItems } from '../products/product';

@Component({
  selector: "app-categories",
  templateUrl: "./categories.component.html",
  styleUrls: ["./categories.component.scss"]
})
export class CategoriesComponent implements OnInit {
  config: Configuration;
  catoriesChildren: CategoryItems[];
  freeOnlyValue: Boolean = false;
  dataLoading: boolean = true;
  currentCategory: Category = {};


  constructor(
    private productsService: ProductsService,
    private route: ActivatedRoute,
    private configurationService: ConfigurationService,
    private router: Router
  ) {
    this.config = configurationService.getConfigurationCache();
  }

  ngOnInit() {

    this.router.events.subscribe((val) => {
      // if navigation event has started
      if (val instanceof NavigationStart) {
        this.dataLoading = true;
      }
      // if navigation has resolved
      if (val instanceof ResolveEnd) {
        // this.dataLoading = false;
      }
    });

    // Get the top level category infomation
    this.route.params
      .pipe(
        filter((params: any) => params.id),
        switchMap(p => this.productsService.getCatoriesSingle(+p["id"]))
      )
      .subscribe(foundCategory => {
        this.currentCategory = foundCategory;
      });

    this.route.data.subscribe((data: { categoryResults: CategoryItems[] }) => {

      this.dataLoading = false;
      this.catoriesChildren = data.categoryResults;
    });
      

  }
}



// WEBPACK FOOTER //
// ./src/app/categories/categories.component.ts